// components/CustomerHeader.tsx
import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { colors, elevation } from '../theme';

interface CustomerHeaderProps {
  isNew: boolean;
  onBack: () => void;
}

export const CustomerHeader: React.FC<CustomerHeaderProps> = ({ isNew, onBack }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={2}
    >
      <Typography variant="h4" component="h1" color={colors.primary.main}>
        {isNew ? "New Customer" : "Customer Details"}
      </Typography>
      <IconButton
        onClick={onBack}
        sx={{
          bgcolor: "background.paper",
          boxShadow: elevation.minimal,
          "&:hover": { bgcolor: "background.paper", opacity: 0.9 },
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    </Box>
  );
};